export default {
  // Basic menus
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.account.logout': 'Logout',
  
  // User menus
  'menu.dashboard': 'Workbench',
  'menu.config': 'Basic Config',
  'menu.asset-library': 'Asset Library',
  'menu.asset-library.basic': 'Basic Assets',
  'menu.asset-library.product': 'Product Assets',
  'menu.asset-library.keyword': 'Keywords',
  'menu.material': 'Materials',
  'menu.material.image': 'Images',
  'menu.material.video': 'Videos',
  'menu.material.article': 'Articles',
  'menu.material.article-command': 'Article AI Commands',
  'menu.media-release': 'Media Publishing',
  'menu.media-release.self-media': 'Self-Media',
  'menu.media-release.media-platform': 'Media Platforms',
  'menu.media-release.overseas': 'Overseas Media',
  'menu.media-release.order-list': 'Release Orders',
  'menu.publish': 'Publish',
  'menu.finance': 'Finance',
  'menu.report': 'Reports',
  'menu.case': 'Cases',
  
  // Agent menus
  'menu.agent': 'User Management',
  'menu.agent.cases': 'Cases',
  'menu.agent.price': 'Price Settings',
  'menu.agent-setting': 'User Settings',
  'menu.agent-setting.keyword': 'Keyword Management',
  'menu.agent-setting.image': 'Image Management',
  'menu.agent-setting.article': 'Article Management',
  'menu.agent-setting.video': 'Video Management',
  'menu.agent-setting.publish-detail': 'Publish Details',
  'menu.agent-setting.auth': 'Authorization Management',
  
  // OEM menus
  'menu.oem': 'OEM',
  'menu.oem.setting': 'Settings',
  'menu.oem.domain': 'Domain',
  
  // Admin menus
  'menu.admin': 'Admin',
  'menu.admin.users': 'Users',
  'menu.admin.price': 'Price Settings',
  'menu.admin.material': 'Materials',
  'menu.admin.publish': 'Publish',
  'menu.admin.finance': 'Finance',
  'menu.admin.oem-domain': 'OEM Domain',
  'menu.admin.oem-site': 'OEM Site Settings',
  'menu.admin.site-setting': 'Site Settings',
  'menu.admin.ai-command': 'Article AI Commands',
  'menu.admin.platform': 'Platform',
  'menu.admin.media-platform-setting': 'Media Platform Settings',
  
  // Exception pages
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
};
